module.exports = __webpack_public_path__ + "html/subscription-current-plan_30a55753e41924c70d85596ae76989fc.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/subscription-current-plan.html
// module id = dYBL
// module chunks = 56